var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "#103300",
    stroke: "#103300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7801 4.22007C13.9205 4.36069 13.9994 4.55132 13.9994 4.75007C13.9994 4.94882 13.9205 5.13944 13.7801 5.28007L6.5301 12.5301C6.38947 12.6705 6.19884 12.7494 6.0001 12.7494C5.80135 12.7494 5.61071 12.6705 5.47009 12.5301L2.2201 9.28007C2.08762 9.13789 2.0155 8.94985 2.01892 8.75554C2.02235 8.56124 2.10106 8.37586 2.23848 8.23844C2.37589 8.10103 2.56128 8.02232 2.75558 8.01889C2.94988 8.01546 3.13792 8.08759 3.2801 8.22007L6.0001 10.9401L12.7201 4.22007C12.8607 4.07962 13.0513 4.00073 13.2501 4.00073C13.4488 4.00073 13.6395 4.07962 13.7801 4.22007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelected);
export default __webpack_public_path__ + "static/media/CheckboxSelected.45a068fe4caf2fa74dd30926d4eabfe4.svg";
export { ForwardRef as ReactComponent };